<template>
    <v-col class="co-documento-opcoes-avancadas">
        <v-expansion-panels flat v-model="opcoesAvancadas">
            <v-expansion-panel>
                <v-expansion-panel-header>
                    Opções avançadas
                    <template v-slot:actions>
                        <v-icon color="primary"> mdi-chevron-down </v-icon>
                    </template>
                </v-expansion-panel-header>

                <v-expansion-panel-content>
                    <v-row no-gutters>
                        <contrato-tag-novo class="documento-tag" :value="value.tags"/>
                    </v-row>

                    <v-row no-gutters>
                        <v-combobox
                            :class="pastaRaizClasses"
                            v-model="pastaSelecionada.pastaNome"
                            item-text="pastaNome"
                            placeholder="Selecione"
                            :rules="pastaRaizRules()"
                            persistent-placeholder
                            clearable
                            hide-details
                            @click="abrirDialogSelecioanrPasta"
                            @click:clear="limparPastaSelecioanda"
                            :disabled="renovacao"
                        >
                            <template v-slot:label>
                                Pasta
                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <v-icon class="ml-1" color="#999" size="18" v-on="on">
                                            mdi-information
                                        </v-icon>
                                    </template>
                                    <span>Selecione o botão para criar ou selecionar pastas e subpastas.</span>
                                </v-tooltip>
                            </template>
                        </v-combobox>
                    </v-row>

                    <v-row no-gutters>
                        <v-text-field
                            name-date="Limite p/ assinaturas"
                            class="required-field mt-8"
                            v-model="value.fimAssinatura"
                            type="date"
                            :rules="[(v) => !!v || 'Informe o campo obrigatório']"
                            hide-details
                        >
                            <template v-slot:label>
                                Limite p/ assinaturas
                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <v-icon class="ml-1" color="#999" size="18" v-on="on">
                                            mdi-information
                                        </v-icon>
                                    </template>
                                    <span>Data limite para os {{ $tc("pt_br.signatario", 2).toLowerCase() }} assinarem. Após essa data não será permitido assinar o {{ $tc("pt_br.documento").toLowerCase() }}.</span>
                                </v-tooltip>
                            </template>
                        </v-text-field>
                    </v-row>

                    <div class="mt-8 d-flex area-vigencias-wrapper">
                        <span class="titulo-vigencias">Controle de vigências</span>
                        <v-alert dense text type="info" color="primary lighten-1" class="justify-space-between py-4 px-5">
                            <span class="alerta-vigencias-informativo">
                                Defina datas de início e fim de vigências e receba notificações antes do final da vigência do {{ $tc("pt_br.documento").toLowerCase() }}.
                            </span>
                        </v-alert>

                        <v-row no-gutters>
                            <v-text-field
                                name-date="Início da vigência"
                                class="required-field"
                                v-model="value.inicioVigencia"
                                type="date"
                                :rules="[(v) => !!v || 'Informe o campo obrigatório']"
                                hide-details
                                persistent-placeholder
                            >
                                <template v-slot:label>
                                    Início da vigência
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-icon class="ml-1" color="#999" size="18" v-on="on">
                                                mdi-information
                                            </v-icon>
                                        </template>
                                        <span>Data informativa ao qual o {{ $tc("pt_br.documento").toLowerCase() }} iniciará a ser válido.</span>
                                    </v-tooltip>
                                </template>
                            </v-text-field>
                        </v-row>

                        <v-row no-gutters>
                            <v-text-field
                                name-date="Término da vigência"
                                :class="fimVigenciaClasses"
                                v-model="value.fimVigencia"
                                type="date"
                                :rules="terminoVigenciaRules()"
                                :disabled="desabilitarDataFim"
                                hide-details
                                persistent-placeholder
                            >
                                <template v-slot:label>
                                    Término da vigência
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-icon class="ml-1" color="#999" size="18" v-on="on">
                                                mdi-information
                                            </v-icon>
                                        </template>
                                        <span>Data informativa que encerra o {{ $tc("pt_br.documento").toLowerCase() }}. Será gerada uma notificação por e-mail antes do final da vigência.</span>
                                    </v-tooltip>
                                </template>
                            </v-text-field>
                        </v-row>

                        <v-row no-gutters>
                            <v-switch
                                class="miniSize"
                                color="primary"
                                @change="limparDataTerminoVigencia()"
                                v-model="desabilitarDataFim"
                                hide-details
                                dense
                                inset
                            >
                                <template v-slot:label>
                                    Sem data de término
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-icon class="ml-1" color="#999" size="14" v-on="on">
                                                mdi-information
                                            </v-icon>
                                        </template>
                                        <span>Indica se o {{ $tc("pt_br.documento").toLowerCase() }} possui data fim de vigência.</span>
                                    </v-tooltip>
                                </template>
                            </v-switch>
                        </v-row>


                        <v-row no-gutters v-if="!renovacao">
                            <v-switch
                                class="miniSize"
                                color="primary"
                                v-model="pularAdicaoSignatarios"
                                hide-details
                                dense
                                inset
                            >
                                <template v-slot:label>
                                    Armazenar {{ $tc("pt_br.documento").toLowerCase() }} sem coleta de assinaturas
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-icon class="ml-1" color="#999" size="14" v-on="on">
                                                mdi-information
                                            </v-icon>
                                        </template>
                                        <span>Ao ativar essa opção o {{ $tc("pt_br.documento").toLowerCase() }} será armazenado na plataforma sem passar pelas etapas de inclusão de {{ $tc("pt_br.signatario", 2).toLowerCase() }} para a assinatura.</span>
                                    </v-tooltip>
                                </template>
                            </v-switch>
                        </v-row>
                    </div>

                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <dialog-selecionar-pasta
            v-if="dialogSelecionar"
            :dialog="dialogSelecionar"
            :pasta-selecionada="pastaSelecionada"
            @fechar="fecharDialogSelecionarPasta"
            @selecionar="selecionarPasta"
            pode-criar
        />
    </v-col>
</template>

<script>
import ContratoTagNovo from '@/views/common/ContratoTagNovo'
import {mapGetters, mapState} from 'vuex'
import moment from 'moment-timezone'
import DialogSelecionarPasta from '@/views/common/dialogs/DialogSelecionarPasta'
import Utils from '@/commons/utils/Utils'

export default {
    name: 'OpcoesAvancadas',
    components: {DialogSelecionarPasta, ContratoTagNovo},
    props: {
        value: {
            required: true
        },
        renovacao: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            dialogSelecionar: false,
            desabilitarDataFim: true,
            opcoesAvancadas: null,
            pastaSelecionada: {},
            pularAdicaoSignatarios: false
        }
    },
    computed: {
        ...mapState(['contrato', 'pastaAtual', 'login']),
        ...mapGetters(['podeCriarContratoRaiz']),
        ehMobile() {
            return this.$vuetify.breakpoint.xsOnly
        },
        fimVigenciaClasses() {
            let classComum = 'mt-8 date-com-check'
            return this.desabilitarDataFim ? classComum : classComum + ' required-field'
        },
        ehContrato() {
            return Utils.possuiValor(this.value.contratoId)
        },
        pastaRaizClasses() {
            return this.podeCriarContratoRaiz ? 'mt-8' : 'required-field mt-8'
        },
    },
    async mounted() {
        this.atualizarPastaAtual()
        if (!this.ehMobile) {
            this.abrirOpcoesAvancadas()
        }
    },
    watch: {
        'value.pastaId'() {
            if (this.renovacao) {
                this.atualizarPastaAtual()
            }
        },
        pularAdicaoSignatarios(val) {
            this.$emit('pular-adicao-signatarios', val)
        }
    },
    methods: {
        abrirDialogSelecioanrPasta() {
            this.dialogSelecionar = true
        },
        abrirOpcoesAvancadas() {
            this.opcoesAvancadas = 0
        },
        atualizarPastaAtual() {
            if (this.renovacao) {
                this.pastaSelecionada.pastaId = this.contrato.pastaId
                this.pastaSelecionada.pastaNome = this.contrato.pastaNome
            } else {
                this.pastaSelecionada.pastaId = this.pastaAtual.pastaId
                this.pastaSelecionada.pastaNome = this.pastaAtual.pastaNome
            }
        },
        ehElementoNaMesmaPasta(pasta) {
            return this.pastaAtual.pastaId === pasta.pastaId
        },
        fecharDialogSelecionarPasta() {
            this.dialogSelecionar = false
        },
        limparDataTerminoVigencia() {
            if (this.desabilitarDataFim) {
                this.value.fimVigencia = null
            } else {
                this.value.fimVigencia = moment(this.value.inicioVigencia).add(7, 'days').format('YYYY-MM-DD')
            }
        },
        limparPastaSelecioanda() {
            this.pastaSelecionada = {
                pastaId: null
            }
        },
        pastaRaizRules() {
            if (this.podeCriarContratoRaiz || this.renovacao) {
                return []
            }
            return [(v) => !!v || 'Informe uma Pasta']
        },
        selecionarPasta() {
            this.value.pastaId = this.pastaSelecionada.pastaId
            if (!this.pastaSelecionada.pastaId) {
                this.limparPastaSelecioanda()
            }
            this.fecharDialogSelecionarPasta()
        },
        terminoVigenciaRules() {
            if (this.desabilitarDataFim) {
                return []
            }
            return [(v) => !!v || 'Informe o Término da Vigência']
        }
    }
}
</script>

<style lang="stylus">
.co-documento-opcoes-avancadas
    .v-expansion-panel
        background-color unset !important

        .documento-tag
            width: 100%

        .v-expansion-panel-header
            color var(--primary)
            padding 0

            .v-icon
                color var(--primary) !important

        .v-expansion-panel-content__wrap
            padding 0

        .area-vigencias-wrapper
            gap 5px
            flex-direction column

            .titulo-vigencias
                font-size 15px
                color var(--primary)

            .alerta-vigencias-informativo
                font-size 12px
                color var(--primary)

    .lSize
        font-family "Roboto", "Segoe UI", "GeezaPro", "DejaVu Serif", "sans-serif"
        font-size 13px
        cursor pointer
        user-select none

    .miniSize
        margin-top 2px

        .v-label
            font-size 12px !important

        .v-input--selection-controls
            &__input
                margin-top 6px !important

            &__input
                width 32px !important

            &__ripple
                height 24px !important
                width 24px !important

        .v-input--switch__thumb
            height 12px !important
            width 12px !important

        .v-input--switch__track
            height 16px !important
            width 38px !important
</style>
